import { ReactNode } from 'react';

import { Stack, StackProps } from '@mui/system';
import { Types } from '@scorenco/core';

import {
  CompetitionRankingColumnDefault,
  CompetitionRankingColumnGnp,
  CompetitionRankingColumnGp,
  CompetitionRankingColumnSerie,
  CompetitionRankingColumnSets,
} from './columns';
import { useCompetitionRankingContext } from './CompetitionRankingContext';

export type CompetitionRankingRowProps = StackProps & {
  ranking?: Types.Competitions_Ranking_Detail;
};

export const CompetitionRankingInfo = ({
  ranking,
  ...rest
}: CompetitionRankingRowProps) => {
  const { columns, highlightTeams } = useCompetitionRankingContext();
  const isHighlight =
    ranking?.team_in_season_id &&
    highlightTeams?.includes(ranking.team_in_season_id);

  return (
    <Stack
      sx={{
        minHeight: '3rem',
        fontSize: '0.85rem',
        letterSpacing: '-0.05em',
        textAlign: 'center',
        alignItems: 'center',
      }}
      direction="row"
      className="competition-ranking-info"
      {...rest}
    >
      {columns.map((col) => {
        if (col === 'pts') {
          return (
            <CompetitionRankingColumnDefault
              className="cell"
              key={col}
              value={ranking?.[col as keyof typeof ranking] as ReactNode}
              sx={[
                {
                  backgroundColor: 'background.default',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                isHighlight
                  ? {
                      fontWeight: 'bold',
                    }
                  : {
                      fontWeight: 'normal',
                    },
              ]}
            />
          );
        }
        if (col === 'gnp') {
          return (
            <CompetitionRankingColumnGnp
              className="cell"
              key={col}
              ranking={ranking}
              sx={[
                isHighlight
                  ? {
                      fontWeight: 'bold',
                    }
                  : {
                      fontWeight: 'normal',
                    },
              ]}
            />
          );
        }

        if (col === 'gp') {
          return (
            <CompetitionRankingColumnGp
              className="cell"
              key={col}
              ranking={ranking}
              sx={[
                isHighlight
                  ? {
                      fontWeight: 'bold',
                    }
                  : {
                      fontWeight: 'normal',
                    },
              ]}
            />
          );
        }

        if (col === 'sets') {
          return (
            <CompetitionRankingColumnSets
              className="cell"
              key={col}
              ranking={ranking}
            />
          );
        }

        if (col === 'serie') {
          return (
            <CompetitionRankingColumnSerie
              className="cell"
              key={col}
              ranking={ranking}
            />
          );
        }

        let value: ReactNode = null;
        if (col === 'sets_g') {
          value = ranking?.gf as ReactNode;
        } else if (col === 'sets_a') {
          value = ranking?.ga as ReactNode;
        } else {
          value = ranking?.[col as keyof typeof ranking] as ReactNode;
        }

        return (
          <CompetitionRankingColumnDefault
            className="cell"
            key={col}
            value={value}
            sx={[
              isHighlight
                ? {
                    fontWeight: 'bold',
                  }
                : {
                    fontWeight: 'normal',
                  },
            ]}
          />
        );
      })}
    </Stack>
  );
};
